// extracted by mini-css-extract-plugin
export default {"wrapper":"Panel_wrapper__R7KpG","container":"Panel_container__-M7eS"};